<template>
  <div :id='randomId'>
    <ejs-listview id='flat-list' ref="listNe" :dataSource='data'></ejs-listview>
  </div>
</template>

<script>
export default {
  name: 'LeftPanelNeList',
  props: [
    'neArr',
    'select',
    'keywords'
  ],
  data() {
    return {
      data: [],
      primaryDatas: [],
      $formId: ''
    };
  },
  computed: {
    randomId() {
      const _temp = 'abcdefghijklmnopqrstuvwxyz';
      this.$formId = '';
      for (let i = 0; i < 5; i++) {
        this.$formId += _temp[Math.round(Math.random(1) * 26)];
      };
      return this.$formId;
    }
  },
  methods: {
    _getNeTreeData() {
      const $this = this;
      $this.data = [];
      this.$axios.post('/lte/ems/auth/findEquipmentListByAuth', this.neArr).then((response) => {
        const _nodeArray = response.data;
        const showData = [];
        const showPrimaryDatas = [];
        _nodeArray.forEach((_item) => {
          const { id, name, equipmentIP, equipmentIPId, typeCode } = _item;
          const _dataItem = {
            text: id + '-' + name,
            id: id,
            neType: typeCode,
            tooltip: equipmentIP,
            equipmentIPId: equipmentIPId
          };
          showData.push(_dataItem);
          showPrimaryDatas.push(_dataItem);
        });
        $this.data = showData;
        $this.primaryDatas = showPrimaryDatas;
      });
    },
    doSearch(keywords) {
      this.keywords = keywords;
      if (this.keywords === '') {
        this.data = this.primaryDatas;
        return;
      }
      const leftNeDatas = this.primaryDatas.filter(neData => (neData.text.includes(this.keywords)));
      this.data = leftNeDatas;
    },
    getNe() {
      return this.$refs.listNe.getSelectedItems();
    }
  },
  beforeMount() {
    this._getNeTreeData();
  },
  updated() {
    const $this = this;
    document.getElementById(this.$formId).onclick = function () {
      $this.select();
    };
  }
};
</script>

<style scoped>

</style>
